<div class="page-header" data-testid="policySearchPageHeader">
  <div class="page-header-text" data-testid="policySearchHeaderText">{{ content.HEADER_TEXT }}</div>
</div>

<div class="page-body" data-testid="policySearchPageBody">
  <div class="body-text" *ngIf="!isPendingPolicy && !isGracePayment">Welcome! We’re happy to have you joining the Nationwide family.</div>
  <div class="body-text" *ngIf="content.BODY_TEXT; else activeBodyText">{{ content.BODY_TEXT }}</div>
  <ng-template #activeBodyText>
    <div class="body-text">Please fill in the required fields below.</div>
  </ng-template>
  <div class="body-text" *ngIf="content.BODY_TEXT_INSTRUCT">
      <span class="body-bold">Note:&nbsp;</span>
      {{ content.BODY_TEXT_INSTRUCT }}
  </div>
  <form [formGroup]="policySearchForm" id="policySearchForm" data-testid="policySearchForm" novalidate>
    <bolt-notification class="tM-20px" data-testid="policySearchValidationError" *ngIf="submitted&& !policySearchForm.valid">Please correct any errors on the page and try again.</bolt-notification>
    <bolt-notification class="tM-20px" data-testid="policyNotFoundError" *ngIf="policyNotFoundError">We couldn't find a policy for you with that information. Please double check and try again.</bolt-notification>
    <bolt-notification class="tM-20px" data-testid="noBillFoundError" *ngIf="noBillFoundError">We couldn’t locate a bill for you or you do not have a balance due. If you have questions, call the Life Insurance Solutions Center at <br /> 1-800-848-6331.</bolt-notification>
    <div class="body-heading" *ngIf="content.SUB_HEADING">{{ content.SUB_HEADING }}</div>
    <div class="body-form">
      <div class="field-label" *ngIf="isGracePayment" id="policyNumberFieldLabel">
        <span class="field-name">{{ content.POLICY }}</span> <span class="field-required">{{ content.REQUIRED_SUFFIX }}</span>
      </div>
      <bolt-textfield class="search-field" data-testid="policyNumberTextField" [label]="isGracePayment ? '' : content.POLICY" [arialabelledby]="isGracePayment ? 'policyNumberFieldLabel' : null" [required]="true" formControlName="policyNumber" minlength="10" maxlength="10" ngDefaultControl
        [instructionaltext]="content.POLICY_INSTRUCTION"
        [error]="policySearchForm.get('policyNumber')?.touched && !policySearchForm.get('policyNumber')?.valid?'Please provide a valid policy number.':null">
      </bolt-textfield>
      <div class="field-label" *ngIf="isGracePayment" id="zipCodeFieldLabel">
        <span class="field-name">{{ content.ZIPCODE }}</span> <span class="field-required">{{ content.REQUIRED_SUFFIX }}</span>
      </div>
      <bolt-textfield class="search-field" data-testid="zipCodeTextField" appNumericOnly inputmode="text" [label]="isGracePayment ? '' : content.ZIPCODE" [arialabelledby]="isGracePayment ? 'zipCodeFieldLabel' : null" [required]="true" formControlName="zipCode" minlength="5" maxlength="5" ngDefaultControl
        [error]="policySearchForm.get('zipCode')?.touched && !policySearchForm.get('zipCode')?.valid?'Please provide a valid ZIP code.':null">
      </bolt-textfield>
      <bolt-input-control data-testid="phoneNumberInputControl">
        <label for="phoneNumber"><span class="field-name">{{ content.PHONE_NUMBER }}</span> <span class="field-required" *ngIf="isGracePayment">{{ content.REQUIRED_SUFFIX }}</span></label>
        <bolt-input-facade>
          <input aria-describedby="phoneNumber" id="phoneNumber" data-testid="phoneNumberTextField" type="text" [mask]="'(000) 000-0000'"
            formControlName="phoneNumber" [required]="true" ngDefaultControl minlength="10" maxlength="14" />
        </bolt-input-facade>
        <footer>
          <p class="bolt-help" id="HELP_ID">Use this format: (555) 555-5555</p>
          <div class="bolt-error" id="ERROR_ID" *ngIf="policySearchForm.get('phoneNumber')?.touched && !policySearchForm.get('phoneNumber')?.valid">
            <bolt-field-error>Please provide a valid phone number.</bolt-field-error>
          </div>
        </footer>
      </bolt-input-control>
    </div>
  </form>
</div>

<div class="page-footer">
  <bolt-button-bar class="footer-button-bar">
    <bolt-button slot="cancel" data-testid="cancelButton" (click)="onCancel()" *ngIf="!isGracePayment">Cancel</bolt-button>
    <bolt-button slot="back" data-testid="backButton" (click)="onBack()" *ngIf="!isGracePayment">Back</bolt-button>
    <bolt-button slot="forward" type="primary" data-testid="continueButton" (click)="onSubmit()">Continue</bolt-button>
  </bolt-button-bar>
</div>